import React, { useContext, useEffect, useState } from "react";
import SlidingDiv from "../Components/SlidingDiv";
import magnifying from '../images/Groups.svg'
import logo from '../images/Groups.png'
import HeroSection from '../images/Image.png'
import porp1Img from '../images/Image (4).png'
import footprop1 from '../images/Frame.png'
import footprop2 from '../images/Frame (1).png'
import footprop3 from '../images/Frame (2).png'


function SingleProperty() {



    return (
        <div>
            <div className="HeroBackGround">

            </div>

            <div className="gapper">

            </div>

            <div className="heroSection">
                <div className="HS1">
                    <div className="HS1img gr">
                        <img src={logo} alt="" />
                        REALTY
                    </div>

                    <div className="HS1txt">
                        <div className="scroll-content gr">
                            <span>SEARCH</span>
                            <span>PROPERTIES</span>
                            <span>AGENTS</span>
                            <span>STORIES</span>

                            {/* Repeat for smooth infinite scroll */}
                            <span>SEARCH</span>
                            <span>PROPERTIES</span>
                            <span>AGENTS</span>
                            <span>STORIES</span>
                        </div>
                    </div>
                </div>

                <div className="HS2">
                    <div className="hs2img gr">
                        <img src={porp1Img} alt="" />
                    </div>
                </div>
            </div>

            <div className="propListingPriv">
                <div className="propTextPriv">

                    <div className="propertyNamePriv gr">
                        2170 Highway 28 <br />
                        Carson City, Nevada, 89703 United States
                    </div>

                    <div className="propertyInfoPriv">
                        <div className="variant">
                            <div className="head">
                                Price
                            </div>
                            <div className="body gel">
                                $25,000,000
                            </div>
                        </div>

                        <div className="variant">
                            <div className="head">
                                BEDROOMS
                            </div>
                            <div className="body gel">
                                5
                            </div>
                        </div>
                        <div className="variant">
                            <div className="head">
                                BATHROOMS
                            </div>
                            <div className="body gel">
                                5 Full
                            </div>
                            <div className="body gel">
                                1 Partial
                            </div>
                        </div>

                        <div className="variant">
                            <div className="head">
                                EXTERIOR
                            </div>
                            <div className="body gel">
                                2.04 Acre(s)
                            </div>
                        </div>
                    </div>

                    <div className="summaryPriv">
                        <div className="nameSummaryPriv gb">
                            Elegant Lakeview Home on
                            Upper Tyner
                        </div>

                        <div className="descrSummaryPriv gr">
                            Located on Lake Tahoe's stunning north shore in tax-friendly Nevada, discover this elegant
                            lakeview mountain retreat. Southern exposure floods the space with natural light, illuminating
                            the soaring beams, Waterford Crystal chandelier, and floor-to-ceiling windows of this sophisticated 5-bed, 4.5-bath home. Enjoy lake vistas from nearly every room. The chef's kitchen is
                            perfect for entertaining, featuring a ten-burner stove, Subzero refrigerator, dual dishwashers,
                            wine fridge, icemaker, and more. The primary suite on the main level offers convenience and
                            single-level living, while downstairs holds a second suite, two bedrooms, family and game
                            rooms. Cozy up to three wood fireplaces after outdoor adventures. With spacious gathering
                            spots, privacy, and ample storage, the home provides a balanced lifestyle. Incline Village owners
                            enjoy three beaches, pools, golf, skiing, recreation center, tennis, and more. Unmatched in amenities, this community offers Lake Tahoe living at its finest.
                        </div>
                    </div>
                </div>
                <div className="propImgPrivListing">

                    <img src={footprop1} alt="" />
                    <img src={footprop2} alt="" />
                    <img src={footprop3} alt="" />
                    <img src={footprop1} alt="" />
                </div>


            </div>





        </div>

    );
}

export default SingleProperty;

